
import { combineReducers } from 'redux';

import {
    GET_USER_PERMISSIONS_ACTION_TYPE,
} from '../../common/client/sagas/mysliveckyportal/userPermissions';

import articles from '../common/articles';
import permissions from '../../common/client/reducers/mysliveckyportal/permissions';

import { GET_ARTICLES_ACTION_TYPE } from '../../sagas/articles';

export function getArticles(state) {
    return state.articles;
}

export function getUserPermissions(state) {
    return state.userPermissions;
}

export default combineReducers({
    articles: articles(GET_ARTICLES_ACTION_TYPE),
    userPermissions: permissions(GET_USER_PERMISSIONS_ACTION_TYPE),
});

